import {
  InfoAreaIcon,
  InfoAvgSalaryIcon,
  InfoPopulationIcon,
} from '../assets/icons';
import {
  BEEF,
  CARROT,
  CHICKEN,
  CUCUMBER,
  EGG,
  LAMB,
  MILK,
  ONION,
  POTATO,
  TOMATO,
} from '../assets/icons/food';
import {
  GAS_SUPPLY,
  INTERNET_ACCESS,
  MOBILE_COMMUNICATION,
  WATER_SUPPY,
} from '../assets/icons/infrastructure';
import {
  GOOD,
  NOT_SATISFACTORY,
  SATISFACTORY,
  TOTAL,
} from '../assets/icons/road';
import {
  AGRICULTURE,
  AVERAGE_MONTHLY_SALARY,
  BIRD,
  CAMEL,
  CHICKEN_EGG,
  CONSTRUCTION,
  COW_MILK,
  CURRENT_MSP,
  EMPLOYED,
  GOAT,
  HORSE,
  HOUSE_COMMISSIONING,
  INCOME_RECEIPT,
  INDUSTRIAL_PRODUCTION,
  INVESTMENT,
  KRC,
  MANUFACTURING_INDUSTRY,
  MEAT,
  MINING_INDUSTRY,
  NEW_WORKPLACE,
  RETAIL,
  SHEEP,
  TRANSPORT_WAREHOUSING,
  UNEMPLOYED,
  WHOLESALE,
} from '../assets/icons/ser';
import {
  FoodSubType,
  IGeneralInfo,
  InfrastructureSubType,
  IStatistics,
  ITotalRoadShareStats,
  SerSubtype,
} from '../types/kato.types';
import { IScreeningFarming } from '../types/screening.types';

export const monthsRu = [
  'января',
  'февраля',
  'марта',
  'апреля',
  'мая',
  'июня',
  'июля',
  'августа',
  'сентября',
  'октября',
  'ноября',
  'декабря',
];

export const monthsKz = [
  'қаңтар',
  'ақпан',
  'наурыз',
  'сәуір',
  'мамыр',
  'маусым',
  'шілде',
  'тамыз',
  'қыркүйек',
  'қазан',
  'қараша',
  'желтоқсан',
];

export const monthList = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
];

export const infoData: {
  valueKey: keyof IGeneralInfo['generalInfo'];
  icon: React.ReactNode;
  title: string;
  valueSuffix: string;
}[] = [
  {
    title: 'population',
    valueKey: 'population',
    valueSuffix: 'people',
    icon: <InfoPopulationIcon />,
  },
  // {
  //     title: 'employment',
  //     valueKey: 'employment',
  //     valueSuffix: 'people',
  //     icon:  <InfoPopulationIcon />,
  // },
  {
    title: 'avgSalary',
    valueKey: 'avgSalary',
    valueSuffix: 'tenge',
    icon: <InfoAvgSalaryIcon />,
  },
  {
    title: 'area',
    valueKey: 'area',
    valueSuffix: 'ga',
    icon: <InfoAreaIcon />,
  },
];

export const snpInfoData: {
  title: string;
  suffix: string;
  icon: React.ReactNode;
  items: {
    title: string;
    valueKey: string;
    parentTitle?: string;
    percentage?: number;
  }[];
}[] = [
  {
    title: 'population',
    suffix: 'people-number',
    icon: <InfoPopulationIcon />,
    items: [
      {
        title: 'total',
        valueKey: 'population',
        percentage: 100,
      },
      {
        title: 'kazakhs',
        valueKey: 'kazakhs',
        parentTitle: 'population',
        percentage: 55.58,
      },
      {
        title: 'russians',
        valueKey: 'russians',
        parentTitle: 'population',
        percentage: 30.12,
      },
      {
        title: 'others',
        valueKey: 'others',
        parentTitle: 'population',
        percentage: 14.3,
      },
    ],
  },
  // {
  //     title: "employment",
  //     suffix: "people-number",
  //     icon: <InfoPopulationIcon />,
  //     parentTitle: 'employment',
  //     items: [
  //         {
  //             title: 'employed',
  //             valueKey: 'employed',
  //         },
  //         {
  //             title: 'self-employed',
  //             valueKey: 'selfEmployed',
  //         },
  //         {
  //             title: 'unemployed',
  //             valueKey: 'unemployed',
  //         },
  //         {
  //             title: 'asp-receivers',
  //             valueKey: 'aspReceivers',
  //         },
  //         {
  //             title: 'others',
  //             valueKey: 'others',
  //         }
  //     ]
  // },
  {
    title: 'avg-salary',
    suffix: 'tenge',
    icon: <InfoAvgSalaryIcon />,
    items: [
      {
        title: 'average',
        valueKey: 'avgSalary',
        percentage: 61,
      },
    ],
  },
];

export const SERSubTypeToIcon: Record<SerSubtype, React.ReactNode> = {
  [SerSubtype.AGRICULTURE]: <AGRICULTURE />,
  [SerSubtype.CONSTRUCTION]: <CONSTRUCTION />,
  [SerSubtype.HOUSE_COMMISSIONING]: <HOUSE_COMMISSIONING />,
  [SerSubtype.INDUSTRIAL_PRODUCTION]: <INDUSTRIAL_PRODUCTION />,
  [SerSubtype.INVESTMENT]: <INVESTMENT />,
  [SerSubtype.MANUFACTURING_INDUSTRY]: <MANUFACTURING_INDUSTRY />,
  [SerSubtype.MINING_INDUSTRY]: <MINING_INDUSTRY />,
  [SerSubtype.TRANSPORT_WAREHOUSING]: <TRANSPORT_WAREHOUSING />,
};

export const SERIcons: Record<string, React.ReactNode> = {
  INDUSTRIAL_PRODUCTION: <INDUSTRIAL_PRODUCTION />,
  MINING_INDUSTRY: <MINING_INDUSTRY />,
  MANUFACTURING_INDUSTRY: <MANUFACTURING_INDUSTRY />,
  AGRICULTURE: <AGRICULTURE />,
  INVESTMENT: <INVESTMENT />,
  HOUSE_COMMISSIONING: <HOUSE_COMMISSIONING />,
  CONSTRUCTION: <CONSTRUCTION />,
  TRANSPORT_WAREHOUSING: <TRANSPORT_WAREHOUSING />,

  INCOME_RECEIPT: <INCOME_RECEIPT />,
  BUDGET_EXPENDITURE: <INCOME_RECEIPT />,

  CURRENT_MSP: <CURRENT_MSP />,
  RETAIL: <RETAIL />,
  WHOLESALE: <WHOLESALE />,

  EMPLOYED: <EMPLOYED />,
  UNEMPLOYED: <UNEMPLOYED />,
  NEW_WORKPLACE: <NEW_WORKPLACE />,
  AVERAGE_MONTHLY_SALARY: <AVERAGE_MONTHLY_SALARY />,

  KRC: <KRC />,
  SHEEP: <SHEEP />,
  GOAT: <GOAT />,
  HORSE: <HORSE />,
  CAMEL: <CAMEL />,
  BIRD: <BIRD />,
  MEAT: <MEAT />,
  COW_MILK: <COW_MILK />,
  CHICKEN_EGG: <CHICKEN_EGG />,
};

export const FoodSubTypeToIcon: Record<FoodSubType, React.ReactNode> = {
  [FoodSubType.BEEF]: <BEEF />,
  [FoodSubType.LAMB]: <LAMB />,
  [FoodSubType.CHICKEN]: <CHICKEN />,
  [FoodSubType.EGG]: <EGG />,
  [FoodSubType.TOMATO]: <TOMATO />,
  [FoodSubType.MILK]: <MILK />,
  [FoodSubType.POTATO]: <POTATO />,
  [FoodSubType.ONION]: <ONION />,
  [FoodSubType.CUCUMBER]: <CUCUMBER />,
  [FoodSubType.CARROT]: <CARROT />,
};

export const InfrastructureSubTypeToIcon: Record<
  InfrastructureSubType,
  React.ReactNode
> = {
  [InfrastructureSubType.GAS_SUPPLY]: <GAS_SUPPLY />,
  [InfrastructureSubType.WATER_SUPPLY]: <WATER_SUPPY />,
  [InfrastructureSubType.INTERNET_ACCESS]: <INTERNET_ACCESS />,
  [InfrastructureSubType.MOBILE_COMMUNICATION]: <MOBILE_COMMUNICATION />,
};

export const RoadSubTypeToIcon: Partial<
  Record<keyof ITotalRoadShareStats, React.ReactNode>
> = {
  curYearTotalFineRoadPercentage: <TOTAL />,
  totalCurYearGoodConditionPercentage: <GOOD />,
  totalCurYearSatisfactoryConditionPercentage: <SATISFACTORY />,
  totalCurYearPoorConditionPercentage: <NOT_SATISFACTORY />,
};

export const colors: Record<string, string> = {
  KPC: '#118F84',
  MPC: '#92D050',
  birds: '#5BC7D9',
  camels: '#6968FD',
  horses: '#595959',
};

export const cropColors: Record<string, string> = {
  grains: '#92D050',
  potato: '#595959',
  carnival: '#5BC7D9',
  vegetables: '#6968FD',
  forage: '#118F84',
};

export const selfSufficiencyKeyToIcon: Record<
  keyof IScreeningFarming['selfSufficiency'],
  any
> = {
  sheep: <LAMB />,
  bird: <CHICKEN />,
  egg: <EGG />,
  cucumber: <CUCUMBER />,
  tomato: <TOMATO />,
};

export const settingsConfig = [
  {
    key: 'indicators',
    children: [
      {
        key: 'snp-info',
        children: [
          { key: 'population' },
          { key: 'employment' },
          { key: 'avg-salary' },
          { key: 'area' },
        ],
      },
      {
        key: 'digital-passport',
        children: [
          { key: 'ser' },
          { key: 'psd' },
          { key: 'population-dynamic' },
          { key: 'budget-investment-projects' },
          { key: 'food' },
          { key: 'infrastructure' },
          { key: 'road' },
          {
            key: 'tax',
            children: [
              { key: 'handform', childtype: 'radio' },
              { key: 'autolink', childtype: 'radio' },
            ],
          },
          { key: 'population-demand' },
          { key: 'media-monitoring' },
        ],
      },
      {
        key: 'screening',
        children: [
          {
            key: 'human-resources',
            children: [
              { key: 'human-resources-population-dynamic' },
              { key: 'population-by-age' },
              { key: 'population-by-social-status' },
              { key: 'human-resources-employment' },
            ],
          },
          {
            key: 'land-fund',
            children: [{ key: 'large-landowners' }, { key: 'land-fund-items' }],
          },
          {
            key: 'agriculture',
            children: [
              { key: 'animal-husbandry' },
              { key: 'agricultural-growth' },
              { key: 'self-sufficiency' },
              { key: 'poultry' },
              { key: 'milk' },
              { key: 'meat' },
              { key: 'crop-area' },
              { key: 'yearly-meat' },
              { key: 'milk-production' },
              { key: 'harvest' },
            ],
          },
          {
            key: 'smb-development',
            children: [
              { key: 'mcb-subjects' },
              { key: 'registered-subjects' },
              { key: 'credit-support' },
              { key: 'total-sum' },
            ],
          },
          {
            key: 'swot-analysis',
            children: [
              { key: 'strengths' },
              { key: 'weaknesses' },
              { key: 'opportunities' },
              { key: 'threats' },
            ],
          },
        ],
      },
      { key: 'program' },
      { key: 'financial-aid' },
    ],
  },
  {
    key: 'projects',
    children: [
      {
        key: 'infrastructure-projects',
        children: [
          { key: 'EDUCATION' },
          { key: 'HEALTH' },
          { key: 'CULTURE_SPORT' },
          { key: 'WATER_SUPPLY' },
          { key: 'INTERNET_COMMUNICATION' },
          { key: 'ACCESS_ROAD' },
          { key: 'VILLAGE_ROAD' },
          { key: 'LIGHTING' },
        ],
      },
      { key: 'SNP_INVESTMENT' },
    ],
  },
  {
    key: 'SNP_IMPROVEMENT',
  },
  {
    key: 'geoportal',
  },
];

export const statisticsKeys: (keyof IStatistics)[] = [
  'total',
  'inProcess',
  'completed',
  'required',
  'completionPercent',
];

export const villageSettingsConfig = [
  {
    key: 'projects',
    children: [
      {
        key: 'infrastructure-projects',
        children: [
          { key: 'EDUCATION' },
          { key: 'HEALTH' },
          { key: 'CULTURE_SPORT' },
          { key: 'WATER_SUPPLY' },
          { key: 'INTERNET_COMMUNICATION' },
          { key: 'ACCESS_ROAD' },
          { key: 'VILLAGE_ROAD' },
          { key: 'LIGHTING' },
        ],
      },
      { key: 'SNP_INVESTMENT' },
    ],
  },
  {
    key: 'SNP_IMPROVEMENT',
  },
  {
    key: 'snp-info',
    children: [
      { key: 'population' },
      { key: 'employment' },
      { key: 'avg-salary' },
      { key: 'area' },
    ],
  },
];
